<template>
  <main class="app-container">
    <div :style="`height: ${height}px;`">


      <list-loading v-show="listData.loading && listData.query.page == 1" />
      <div class="no-result" v-show="!listData.loading && listData.data.length < 1">没有记录</div>
      <md-scroll-view
              ref="scrollView"
              :scrolling-x="false"
              @end-reached="onReachBottom"
      >
        <md-field v-for="item in listData.data"
                  :title="`课程编号：${item.no}`"
                  :key="item.id">
          <md-detail-item title="地点" :content="item.place" />
          <md-detail-item title="日期" :content="`${item.start_day}至${item.end_day}`" />
          <md-detail-item title="时间" :content="`${item.time_period} (${item.week_day})`" />
          <md-detail-item title="已报" :content="item.enrolls_count + ' 人'">

          </md-detail-item>

          <md-detail-item class="operation" title="">
            <router-link :to="{ name: 'leader-enrolls', query: { courseId: item.id }}">查看报名记录</router-link>
          </md-detail-item>
        </md-field>

        <md-scroll-view-more
                slot="more"
                finished-text=""
                :is-finished="listData.hasNextPage == false"
        >
        </md-scroll-view-more>
      </md-scroll-view>
    </div>
  </main>
</template>

<script>

    import { Field, DetailItem,ScrollView, ScrollViewMore } from 'mand-mobile'
    import EnrollDetail from "../../components/EnrollDetail.vue";
    import ListLoading from "../../components/ListLoading.vue";
    import listDataMixin from "../../mixins/list-data";

    export default {
        name: "CoursePlan",
        components: {
            [Field.name]: Field,
            [DetailItem.name]: DetailItem,
            [ScrollView.name]: ScrollView,
            [ScrollViewMore.name]: ScrollViewMore,
            EnrollDetail,ListLoading,
        },
        mixins: [listDataMixin],

        data() {
            return {
                apiEndpoint: 'courses/leader',
                height: window.screen.height,
            }
        },
        methods: {

        },
        created() {
            this.loadListData();
        },
    };
</script>


<style lang="scss" scoped>
  .md-field{
    margin-bottom: 20px;
  }
</style>
